const euroSign = '€'
export const formatMoney = function (num, decPlaces = 2, thouSeparator = '.', decSeparator = ',') {
	let n = Number(num)
	const sign = n < 0 ? '-' : ''
	const i = parseInt((n = Math.abs(+n || 0).toFixed(decPlaces))) + ''
	const j = i.length > 3 ? i.length % 3 : 0

	return (
		sign +
		euroSign +
		' ' +
		(j ? i.substr(0, j) + thouSeparator : '') +
		i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thouSeparator) +
		(decPlaces
			? decSeparator +
				Math.abs(n - i)
					.toFixed(decPlaces)
					.slice(2)
			: '')
	)
}
